module.exports = __webpack_public_path__ + "static/media/plan.d51b7ab4.svg";